import { FC, PropsWithChildren } from 'react';
import { cn } from 'utils/cn';

/**
 * Fixed-height slot for the totals row above a table. The min-height must fit every content
 * variant (totals text, compact limit-exceeded alert, empty loading placeholder) so the slot
 * never changes height — otherwise the table below shifts when totals load in or the variant
 * swaps (CLS).
 */
const TableTotalsWrapper: FC<{ isLoading: boolean } & PropsWithChildren> = ({ children, isLoading }) => {
    return (
        <div
            className={cn('flex min-h-7 items-center gap-2 transition-opacity duration-250', isLoading && 'opacity-30')}
        >
            {children}
        </div>
    );
};

export default TableTotalsWrapper;
